import React, { FC } from "react";
import { IButtonProps } from "types/components/common/btn";
import { primary300 } from "constantVariables";
import { twMerge } from "tailwind-merge";

const PrimaryButton: FC<IButtonProps> = ({
  children,
  color,
  className,
  ...rest
}) => {
  return (
    <button
      className={twMerge('rounded-2xl p-4 text-white font-medium text-lg', className || "")}
      {...rest}
      style={{ backgroundColor: color || primary300 }}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
